import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const scrollToCheckout = () => {
  const checkoutButton = document.getElementById('checkout-button');
  if (checkoutButton) {
    checkoutButton.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
const faqs = [{
  question: '¿Cómo recibo los materiales?',
  answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el acceso a nuestra plataforma donde podrás descargar todo el material organizado por carpetas.'
}, {
  question: '¿Es editable?',
  answer: 'Sí, todo el material se entrega en formato PDF y también incluimos versiones editables (Word/PowerPoint) donde corresponde para que puedas adaptarlo a tu escuela.'
}, {
  question: '¿Durante cuánto tiempo tengo acceso?',
  answer: 'El acceso es de por vida. Una vez que comprás el Mega Pack, podés descargarlo las veces que quieras y usarlo todos los años.'
}, {
  question: '¿Es seguro comprar aquí?',
  answer: 'Totalmente. Procesamos los pagos a través de una plataforma encriptada y segura. No almacenamos tus datos de tarjeta.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gray-50" data-id="element-64">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-65">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-66">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-67">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-68">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-69">
                <span className="font-bold text-gray-800 text-lg" data-id="element-70">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-71" />
              </button>

              <AnimatePresence data-id="element-72">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-73">
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-74">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-75">
          <button onClick={scrollToCheckout} className="bg-yellow-400 text-blue-900 font-bold py-3 px-8 rounded-full shadow-md hover:bg-yellow-300 transition-colors uppercase tracking-wide cursor-pointer" data-id="element-76">
            QUIERO ACCEDER AHORA
          </button>
        </div>
      </div>
    </section>;
}